module.exports = __webpack_public_path__ + "img/logo-kkpoints.5acf0140.png";